import React from "react";
import ReactDOM from "react-dom";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import "./index.css";
import App from "./App";

ReactDOM.render(<App />, document.getElementById("root"));
